import { main as axios } from "../axios";
import hostConfig from "@/config/hostResolver";

const baseUrl = `${
  process.env.VUE_APP_PROGRAM_URL ?? `${hostConfig.apiBaseUrl}/program-service`
}/v2/program-claim`;

class ProgramClaimService {
  async getProgramClaims({
    userId,
    reviewStatus,
    formSubmissionId,
    sortBy,
    sortOrder,
    limit,
    offset,
  }) {
    const response = await axios.get(`${baseUrl}`, {
      params: {
        userId,
        reviewStatus,
        formSubmissionId,
        sortBy,
        sortOrder,
        limit,
        offset,
      },
    });

    return {
      count: response.data.result.count,
      rows: response.data.result.rows,
    };
  }

  async getFormSubmissions({ reviewStatus }) {
    const response = await axios.get(`${baseUrl}/form-submissions`, {
      params: {
        reviewStatus,
      },
    });
    return response.data.result;
  }

  async paxUpdateClaim({ formId, formSubmissionId }) {
    const response = await axios.patch(`${baseUrl}`, {
      formId,
      formSubmissionId,
    });
    return response.data.result;
  }

  async fetchAuditClaimsRecords(
    {
      limit,
      offset,
      format = "json",
      claimId,
      reviewStatus,
      salesDateStart,
      salesDateEnd,
      claimDateStart,
      claimDateEnd,
      dealerName,
      submitterName,
      sort,
      clientId,
    },
    disableCache = false
  ) {
    const params = {
      limit,
      offset,
      format,
      claimId,
      reviewStatus,
      salesDateStart,
      salesDateEnd,
      claimDateStart,
      claimDateEnd,
      dealerName,
      submitterName,
      sort,
      clientId,
    };

    if (disableCache) {
      params._t = Date.now();
    }

    const config = {
      params,
    };

    if (disableCache) {
      config.headers = {
        "Cache-Control": "no-cache, no-store, must-revalidate, max-age=0",
        Pragma: "no-cache",
        Expires: "0",
      };
    }
    if (format === "csv") {
      config.responseType = "blob";
    }

    const response = await axios.get(`${baseUrl}/audit-dashboard`, config);

    if (format === "csv") {
      return { blob: response.data, headers: response.headers };
    }

    // Default json response
    return {
      rows: response.data.result.rows,
      count: response.data.result.count,
    };
  }

  async updateAuditClaimsRecord({
    userId,
    formSubmissionEntryId,
    formId,
    formSubmissionId,
    reviewStatus,
    reviewerComment,
    clientId,
  }) {
    const response = await axios.patch(`${baseUrl}/review-claims`, {
      userId,
      formSubmissionEntryId,
      formId,
      formSubmissionId,
      reviewStatus,
      reviewerComment,
      clientId,
    });
    return response.data.result;
  }
}

export default new ProgramClaimService();
